import { render, staticRenderFns } from "./TopBarReminderList.vue?vue&type=template&id=d44b023a"
import script from "./TopBarReminderList.vue?vue&type=script&lang=js"
export * from "./TopBarReminderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports